module.exports = __webpack_public_path__ + "media/icon/icon-hot_tub-green-422feea7.svg";